export default "__VITE_ASSET__DftLZjtK__"